export const baseURL = `${window.location.origin}/`;
export const adminBaseURL = "https://admin.streamfy.info/";
export const key = "?5m$XnNOg|gGK0&bFrf7Rg}JDl}$96_Y";
